"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bottomBlockTemplate = void 0;
var tslib_1 = require("tslib");
var bottom_block_dot_1 = (0, tslib_1.__importDefault)(require("./bottom-block.dot"));
var bottomBlockTemplate = bottom_block_dot_1.default.default ? bottom_block_dot_1.default.default : bottom_block_dot_1.default;
exports.bottomBlockTemplate = bottomBlockTemplate;
//# sourceMappingURL=index.js.map